import React from 'react';
import CustomProductTable from '../components/CustomProduct/CustomProductTable/CustomProductTable';
import './CustomProductGeneratorPage.css';



const AmazonGeneratorPage: React.FC = () => {
    return (
        <div className="custom-product-generator-page">
            <CustomProductTable />
        </div>
    );
};

export default AmazonGeneratorPage;
